import React from 'react';
import styled from 'styled-components';
import SmallButtonStyled from './Buttons/SmallButtonStyled';

const BoardHeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  box-shadow: 0 4px 6px 0 rgba(40, 40, 58, 0.13);

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: rgba(40, 56, 144, 0.1);
    bottom: 0;
    left: 0;
  }
`;

const BoardHeaderStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-family: NunitoSans;
  font-size: 14px;
  color: #28283a;
`;

const ButtonGroup = styled.div`
  display: flex;
  & div + div {
    margin-left: 8px;
  }
`;

const Button = ({ button, disabledButton, ...props }) => {
  const disabled = disabledButton || button.disabled;
  const onClick = disabled ? null : button.handler;

  return (
    <SmallButtonStyled {...props} onClick={onClick} disabled={disabled}>
      {button.name}
    </SmallButtonStyled>
  );
};

const BoardHeader = ({ button, buttons, disabledButton, children }) => (
  <BoardHeaderWrapper>
    <BoardHeaderStyled>{children}</BoardHeaderStyled>
    {button && (
      <SmallButtonStyled onClick={disabledButton ? null : button.handler} disabled={disabledButton}>
        {button.name}
      </SmallButtonStyled>
    )}
    {Boolean(buttons?.length) && (
      <ButtonGroup>
        {buttons.map((button, index) => (
          <Button key={`header-btn-${index}`} button={button} disabledButton={disabledButton} />
        ))}
      </ButtonGroup>
    )}
  </BoardHeaderWrapper>
);

const ActiveBoardHeader = styled(BoardHeader)``;

export default ActiveBoardHeader;
